<template>
    <div>
        <Header/>
      
			<div class="container">
				<div class="container my-4" v-if="loader">
					<i class="fa fa-spinner fa-spin product-loader centered"></i>
				</div>

				<template v-if="highlightEvents.length">
					<div class="title-wrap my-4">
							<h3 class="section-title section-bg-white">Highlighted Events</h3>
					</div>
						
					<div class="first-product-area product-area my-4">
							<div class="tab-content jump">
									<div class="tab-pane" :class="{active: all}">									
										<div class="row">
												<div class="col-lg-4 col-12" v-for="event in highlightEvents" :key="event.id">
														<div class="product-wrapper event-container p-2 mb-25">
																<div class="product-img">
																		<router-link :to="{name: 'Event' , params:{ id: event.alias }}">
																			<span class="date-badge badge badge-danger">{{ getDay(event.start_date) }} <br> {{ getMonth(event.start_date) }}</span>
																				<img class="image" :src="serverUrl + '/storage/events/' + event.main_photo" alt="Event Poster">
																		</router-link>
																</div>
																<div class="product-content">
																		<h4 class="event-name">
																			<router-link class="a-event-name" :to="{name: 'Event' , params:{ id: event.alias }}">
																					{{ nameChecker(event.name) }}
																			</router-link>
																		</h4>
																		<p class="text-dark mb-0"><i class="fas fa-map-marker-alt"></i><i>{{event.venue}}</i></p>
																</div>
														</div>
												</div>
										</div>
									</div>
							</div>
					</div>
				</template>

				<template v-if="allEvents.length">
					<div class="title-wrap my-4">
							<h3 class="section-title section-bg-white">Upcoming Events</h3>
					</div>

					<div class="first-product-area product-area my-4">
							<div class="tab-content jump">
									<div class="tab-pane" :class="{active: all}">
										<div class="row">
												<div class="col-lg-4 col-12" v-for="event in allEvents" :key="event.id">
														<div class="product-wrapper event-container p-2 mb-25 shadow">
																<div class="product-img">
																		<router-link :to="{name: 'Event' , params:{ id: event.alias }}">
																			<span class="date-badge badge badge-danger">{{ getDay(event.start_date) }} <br> {{ getMonth(event.start_date) }}</span>
																				<img class="image" :src="serverUrl + '/storage/events/' + event.main_photo" alt="Event Poster">
																		</router-link>
																</div>
																<div class="product-content">
																		<h4 class="event-name">
																				<router-link class="text-dark" :to="{name: 'Event' , params:{ id: event.alias }}">
																						{{ nameChecker(event.name) }}
																				</router-link>
																		</h4>
																		
																		<p class="text-dark mb-0"><i>{{event.venue}}</i></p>
																</div>
														</div>
												</div>
										</div>
									</div>
							</div>
					</div>
				</template>
			</div>
        <Footer/>
    </div>
</template>

<script>
		import { mapState} from "vuex";
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
		import Events from "../apis/events";

    export default {
    name: 'Home',
    components: {
        Header,
        Footer
    },

    data () {
        return {
            allEvents: {},
						highlightEvents: {},
						all: true,
						slide: 0,
        		sliding: null,
						loader: true,
        }
    },

    created: function () {
        this.getEvents()
    },

		computed: {
    ...mapState(["serverUrl"]),
  	},

		methods: {
			getEvents() {
				var that = this;

				Events.home()
					.then((response) => {
						that.loader = false
						
						that.allEvents = response.data.allEvents
						that.highlightEvents = response.data.highlightEvents
					})
					.catch(function (error) {
						
					});
			},

			onSlideStart(slide) {
        this.sliding = true
      },

      onSlideEnd(slide) {
        this.sliding = false
      },

			nameChecker(productName) {
				if(productName != null)
					return (productName.length > 25) ? productName.substr(0, 24) + '...' : productName;
			},

			getDay(date) {
				var dateObj = new Date(date)

				return dateObj.getDate()
			},

			getMonth(date) {
				var dateObj = new Date(date)
				var month = dateObj.toLocaleString('en-US', {month: 'short'})

				return month.toUpperCase()
			}
		}
}
</script>